import { authConstants } from '../constants';

export function reg(state = {}, action) {
  switch (action.type) {
    case authConstants.REGISTER_REQUEST:
      return { 
        registering: true,
        user: action.user
       };
    case authConstants.REGISTER_SUCCESS:
      return {
        registered: true,
        user: action.user
      };
    case authConstants.REGISTER_FAILURE:
      return {
        registering: false,
        registered : false,
        user: action.user,
        error: action.error
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/reg.reducer.js